export default __webpack_public_path__ + "static/media/Icon-Controls-Outline-Setting-2.37b3a0d2.svg";